import { utils as xlsxUtils, SSF } from 'xlsx';

let SheetFromArrayOfObjects = function (data, headers, preHeaderRow, printedHeaders) {
  var sheet = {};
  var range = { s: { c: 10000000, r: 10000000 }, e: { c: 0, r: 0 } };

  var extraHeaders = [];
  if (preHeaderRow) extraHeaders.push(preHeaderRow);
  // If an array of printedHeaders is included, use that as the main
  // row of headers, rather than the values in headers
  if (printedHeaders) {
    extraHeaders.push(printedHeaders);
  }
  // If no printedHeaders is included, then just use the values in headers
  else if (headers) {
    extraHeaders.push(headers);
  }

  // Go to data.length + extraHeaders.length because we have to
  // account for the offset extra header rows
  for (var R = 0; R < data.length + extraHeaders.length; R++) {
    for (var C = 0; C < headers.length; C++) {
      // Update the range
      if (range.s.r > R) range.s.r = R;
      if (range.s.c > C) range.s.c = C;
      if (range.e.r < R) range.e.r = R;
      if (range.e.c < C) range.e.c = C;
      // Get the current value (if R == 0, then use the header value)

      if (R < extraHeaders.length) var cell = { v: extraHeaders[R][C] };
      else var cell = { v: data[R - extraHeaders.length][headers[C]] };
      if (cell.v == null) continue;
      if (typeof cell.v === 'object') cell.v = 'Object';
      // Save to cell object
      var cellRef = xlsxUtils.encode_cell({ c: C, r: R });
      // Set the cell type
      if (typeof cell.v === 'number') cell.t = 'n';
      else if (typeof cell.v === 'boolean') cell.t = 'b';
      else if (cell.v instanceof Date) {
        cell.t = 'n';
        cell.z = SSF._table[14];
        cell.v = datenum(cell.v);
      } else cell.t = 's';
      // Save the cell
      sheet[cellRef] = cell;
    }
  }
  if (range.s.c < 10000000) sheet['!ref'] = xlsxUtils.encode_range(range);
  return sheet;
};
export { SheetFromArrayOfObjects };
